export default (state={}) => state;


// WEBPACK FOOTER //
// ./src/modules/OurTeam/reducer.js